export default __webpack_public_path__ + "static/media/zodiacToto-Tiger.4afcadc0.png";